import './index.css'


// WEBPACK FOOTER //
// ./ecology9/wea-locale-provider/style/index.js